<template>
  <div>
    <base-breadcrumb-bar
      :pageTitle="'Manage Auctions'"
      :tabItems="tabs"
      :tab.sync="tab"
      :initialTab="tab"
    >
      <template v-slot:filterBlock>
        <auction-filter
          v-for="(e, i) in tabs"
          :keys="i"
          :queryLimit="e.queryLimit"
          :type="e.type"
          :areaFilters.sync="e.search"
          v-if="i == tab"
        />
        <!-- put display none to just hide but to retain data -->

        <v-row> </v-row>
      </template>
    </base-breadcrumb-bar>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(e, i) in tabs" :keys="i">
        <auction-section
          v-if="tab == i"
          :queryLimit="e.queryLimit"
          :type="e.type"
          :search="e.search"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AuctionSection from "@/components/Base/Auction/AuctionSection";
import AuctionFilter from "@/components/Base/Auction/AuctionFilter";

export default {
  name: "ViewAdmins",
  components: {
    AuctionSection,
    AuctionFilter,
  },
  data() {
    return {
      tabs: [
         {
          text: "Auctions",
          icon: "fi fi-br-auction",
          queryLimit: { description: "Auctions" },
          type: "auction",
          search: {},
        },
      ],
      tab: 0,
      currentAreas: [],
    };
  },
  apollo: {},
  computed: {},
  methods: {},
  watch: {},
};
</script>
